const Magnifier = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.33301 0.333496C9.64501 0.333496 12.333 3.0215 12.333 6.3335C12.333 9.6455 9.64501 12.3335 6.33301 12.3335C3.02101 12.3335 0.333008 9.6455 0.333008 6.3335C0.333008 3.0215 3.02101 0.333496 6.33301 0.333496ZM6.33301 11.0002C8.91101 11.0002 10.9997 8.9115 10.9997 6.3335C10.9997 3.75483 8.91101 1.66683 6.33301 1.66683C3.75434 1.66683 1.66634 3.75483 1.66634 6.3335C1.66634 8.9115 3.75434 11.0002 6.33301 11.0002ZM11.9897 11.0475L13.8757 12.9328L12.9323 13.8762L11.047 11.9902L11.9897 11.0475Z"
        fill="#2D333C"
      />
    </svg>
  );
};

export default Magnifier;
